import React from "react";

function createPagination(page, setPage, numberOfPages, items, itemsPerPage) {
  let pagination = [];
  //   if (page > 1) {
  pagination.push(
    <button
      onClick={() => setPage(page > 1 ? page - 1 : numberOfPages)}
      className={`mdn-Button mdn-Button--icon mdn-Button--secondary`}
    >
      <span className={`mdn-Icon-esquerda mdn-Icon--sm`}></span>
    </button>
  );
  //   }

  for (let index = 1; index < numberOfPages + 1; index++) {
    let btType = index === page ? "primary" : "secondary";

    pagination.push(
      <button
        onClick={() => setPage(index)}
        className={`mdn-Button mdn-Button--icon mdn-Button--${btType}`}
      >
        {index}
      </button>
    );
  }

  //   if (page < items.length / itemsPerPage) {
  pagination.push(
    <button
      onClick={() => setPage(page < numberOfPages ? page + 1 : 1)}
      className={`mdn-Button mdn-Button--icon mdn-Button--secondary`}
    >
      <span className={`mdn-Icon-direita mdn-Icon--sm`}></span>
    </button>
  );
  //   }

  return pagination;
}

export { createPagination };
